import React from 'react'

function Lawyers() {
  return (
    <div>Lawyers</div>
  )
}

export default Lawyers